const config = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  ENV_NAME: process.env.REACT_APP_ENV_NAME,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  SENTRY_SIMPLE_RATE: process.env.REACT_APP_SENTRY_SIMPLE_RATE,
};

export default config;
